'use client'

import React, { useState } from 'react'

import { CMSLink } from '@/theme/components/CMSLink'
import type { GeneralInformation } from '@/payload-types'

type Props = {
  navigationItems: GeneralInformation['navigationItems']
  cta?: GeneralInformation['callToAction']
  showCta?: boolean | null
}

export const HeaderNav: React.FC<Props> = ({ navigationItems, cta, showCta }) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <nav aria-label="Navigation principale">
        <ul className="nav-links">
          {navigationItems?.map((item, i) => (
            <li key={i}>
              <CMSLink {...item.linkWithMedia} appearance="inline" />
            </li>
          ))}
          {showCta && cta && (
            <li>
              <CMSLink {...cta} appearance="default" />
            </li>
          )}
        </ul>
      </nav>
      <button
        type="button"
        className="nav-mobile-toggle"
        aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'}
        aria-expanded={open}
        aria-controls="nav-mobile-panel"
        onClick={() => setOpen((v) => !v)}
      >
        {open ? '✕' : '☰'}
      </button>
      <nav
        id="nav-mobile-panel"
        aria-label="Navigation principale (mobile)"
        className={`nav-mobile-panel${open ? ' open' : ''}`}
      >
        {navigationItems?.map((item, i) => (
          <CMSLink
            key={i}
            {...item.linkWithMedia}
            appearance="inline"
            onClick={() => setOpen(false)}
          />
        ))}
        {showCta && cta && <CMSLink {...cta} appearance="inline" onClick={() => setOpen(false)} />}
      </nav>
    </>
  )
}
